import {isMobile} from '@netx/core/utils';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next';

export const userCanRepurpose = (): boolean => {
    if (isMobile()) return false;
    if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
    return currentUserHasAccess(PermissionName.DOWNLOAD);
};
